import { createReducer, on } from '@ngrx/store';
import { ProductDocumentType } from '../../../enums/product-document-type.enum';
import { downloadDocument, emptyDocumentData, loadDocument, loadDocumentError, loadDocumentFinished } from './document.actions';

export const documentsFeatureKey = 'docData';
export interface DocState {
    documentData: DocumentData[];
}
export interface DocumentData {
    docType: string;
    url: string;
    isLoading: boolean; // Set when the document is loading
    contractId?: string;
    orgType?: string;
    isURLFound: boolean; // Set when the URL is found
    urlExpires?: number; // seconds
    createdDateTime?: string;
}

export const initialState: DocState = {
    documentData: []
};

export const documentReducer = createReducer(
    initialState,
    on(loadDocument, state => {
        return {
            ...state,
            documentData: [
                ...state.documentData,
                { docType: ProductDocumentType.InspectionCertificate, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true },
                { docType: ProductDocumentType.StockInspectionCertificate, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true },
                { docType: ProductDocumentType.SafetyInstruction, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true },
                { docType: ProductDocumentType.StockSafetyInstruction, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true },
                { docType: ProductDocumentType.ServiceCertificate, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true },
                { docType: ProductDocumentType.StockServiceCertificate, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true }
            ]
        };
    }),
    on(loadDocumentFinished, (state, { documentData }) => {
        const withoutTheOne = [...state.documentData].filter(doc => doc.docType !== documentData.docType);
        const withAll = [...withoutTheOne, documentData];
        return {
            ...state,
            documentData: withAll
        };
    }),
    on(emptyDocumentData, state => {
        return { ...state, documentData: [] };
    }),
    on(downloadDocument, (state, { documentType }) => {
        return { ...state, documentData: [...state.documentData, { docType: documentType, url: '', contractId: '', orgType: '', isURLFound: false, isLoading: true }] };
    }),
    on(loadDocumentError, (state: DocState, { documentData, error }) => {
        const withoutTheOne = [...state.documentData].filter(doc => doc.docType !== documentData.docType);
        const withAll = [...withoutTheOne, documentData];
        return {
            ...state,
            documentData: withAll,
            error
        };
    })
);
